import { useEffect, useState } from "react";

import { NormHttpService } from "@/modules/assessments/scenes/AddTests/services/norm-http.service";

import { INormSummary } from "@/shared/services/norms/norms-http.service";
import { isValidNumericParam } from "@/shared/utils/common.utils";

export function useBatchTestNormsHook(
  clientId: number | undefined,
  assessmentId: number | undefined,
  testIds: number[],
) {
  const [normsMap, setNormsMap] = useState<{ [testId: number]: INormSummary[] }>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchNorms = async () => {
      try {
        if (!clientId || !assessmentId || testIds.length === 0) {
          setNormsMap({});
          setIsLoading(false);
          return;
        }

        setIsLoading(true);
        const norms: INormSummary[] = await NormHttpService.getNormsByTestIds(clientId, assessmentId, testIds);
        const grouped = groupNormsByTestId(norms);

        setNormsMap(grouped);
      } catch (e) {
        console.error(`Error fetching norms: ${e}`);
      } finally {
        setIsLoading(false);
      }
    };

    if (isValidNumericParam(clientId)) {
      fetchNorms();
    }
  }, [clientId, assessmentId, testIds]);

  return { normsMap, isLoading };
}

export function groupNormsByTestId(norms: INormSummary[]): { [testId: number]: INormSummary[] } {
  const grouped: { [testId: number]: INormSummary[] } = {};
  norms.forEach((norm) => {
    if (!grouped[norm.testId]) {
      grouped[norm.testId] = [];
    }
    grouped[norm.testId].push(norm);
  });
  return grouped;
}
